// FETCH PERSON INFO

export const FETCH_PERSON_INFO = 'FETCH_PERSON_INFO';
export const FETCH_PERSON_INFO_PENDING = 'FETCH_PERSON_INFO_PENDING';
export const FETCH_PERSON_INFO_FULFILLED = 'FETCH_PERSON_INFO_FULFILLED';
export const FETCH_PERSON_INFO_REJECTED = 'FETCH_PERSON_INFO_REJECTED';

// FETCH TITLE INFO

export const FETCH_TITLE_INFO = 'FETCH_TITLE_INFO';
export const FETCH_TITLE_INFO_PENDING = 'FETCH_TITLE_INFO_PENDING';
export const FETCH_TITLE_INFO_FULFILLED = 'FETCH_TITLE_INFO_FULFILLED';
export const FETCH_TITLE_INFO_REJECTED = 'FETCH_TITLE_INFO_REJECTED';

// FETCH GENRES ID

export const FETCH_GENRES_MOVIES_ID = 'FETCH_GENRES_MOVIES_ID';
export const FETCH_GENRES_MOVIES_ID_FULFILLED =
  'FETCH_GENRES_MOVIES_ID_FULFILLED';
export const FETCH_GENRES_MOVIES_ID_REJECTED =
  'FETCH_GENRES_MOVIES_ID_REJECTED';

export const FETCH_GENRES_TV_ID = 'FETCH_GENRES_TV_ID';
export const FETCH_GENRES_TV_ID_FULFILLED = 'FETCH_GENRES_TV_ID_FULFILLED';
export const FETCH_GENRES_TV_ID_REJECTED = 'FETCH_GENRES_TV_ID_REJECTED';

// MOVIES

export const FETCH_UPCOMING = 'FETCH_UPCOMING';
export const FETCH_UPCOMING_FULFILLED = 'FETCH_UPCOMING_FULFILLED';
export const FETCH_UPCOMING_REJECTED = 'FETCH_UPCOMING_REJECTED';

export const FETCH_TOP_RATED = 'FETCH_TOP_RATED';
export const FETCH_TOP_RATED_PENDING = 'FETCH_TOP_RATED_PENDING';
export const FETCH_TOP_RATED_FULFILLED = 'FETCH_TOP_RATED_FULFILLED';
export const FETCH_TOP_RATED_REJECTED = 'FETCH_TOP_RATED_REJECTED';

export const FETCH_POPULAR = 'FETCH_POPULAR';
export const FETCH_POPULAR_FULFILLED = 'FETCH_POPULAR_FULFILLED';
export const FETCH_POPULAR_REJECTED = 'FETCH_POPULAR_REJECTED';

export const FETCH_NOW_PLAYING = 'FETCH_NOW_PLAYING';
export const FETCH_NOW_PLAYING_FULFILLED = 'FETCH_NOW_PLAYING_FULFILLED';
export const FETCH_NOW_PLAYING_REJECTED = 'FETCH_NOW_PLAYING_REJECTED';

export const FETCH_TRENDING = 'FETCH_TRENDING';
export const FETCH_TRENDING_FULFILLED = 'FETCH_TRENDING_FULFILLED';
export const FETCH_TRENDING_REJECTED = 'FETCH_TRENDING_REJECTED';

// UI ACTIONS

export const NAV_TOGGLE = 'NAV_TOGGLE';

export const CHANGE_TYPE_MOVIE = 'CHANGE_TYPE_MOVIE';

export const CHANGE_TYPE_TV = 'CHANGE_TYPE_TV';

// TV

export const FETCH_AIRING_TODAY = 'FETCH_AIRING_TODAY';
export const FETCH_AIRING_TODAY_FULFILLED = 'FETCH_AIRING_TODAY_FULFILLED';
export const FETCH_AIRING_TODAY_REJECTED = 'FETCH_AIRING_TODAY_REJECTED';

export const FETCH_ON_THE_AIR = 'FETCH_ON_THE_AIR';
export const FETCH_ON_THE_AIR_FULFILLED = 'FETCH_ON_THE_AIR_FULFILLED';
export const FETCH_ON_THE_AIR_REJECTED = 'FETCH_ON_THE_AIR_REJECTED';

export const FETCH_POPULAR_TV = 'FETCH_POPULAR_TV';
export const FETCH_POPULAR_TV_FULFILLED = 'FETCH_POPULAR_TV_FULFILLED';
export const FETCH_POPULAR_TV_REJECTED = 'FETCH_POPULAR_TV_REJECTED';

export const FETCH_TOP_RATED_TV = 'FETCH_TOP_RATED_TV';
export const FETCH_TOP_RATED_TV_FULFILLED = 'FETCH_TOP_RATED_TV_FULFILLED';
export const FETCH_TOP_RATED_TV_REJECTED = 'FETCH_TOP_RATED_TV_REJECTED';

// Search Queries

export const MULTI_SEARCH = 'MULTI_SEARCH';
export const MULTI_SEARCH_PENDING = 'MULTI_SEARCH_PENDING';
export const MULTI_SEARCH_FULFILLED = 'MULTI_SEARCH_FULFILLED';

// search page infinite scroll

export const INF_SEARCH = 'INF_SEARCH';
export const INF_SEARCH_PENDING = 'INF_SEARCH_PENDING';
export const INF_SEARCH_FULFILLED = 'INF_SEARCH_FULFILLED';

// input handle

export const SEARCH_QUERY_CHANGED = 'SEARCH_QUERY_CHANGED';

// handle select on search page

export const SELECT_VALUE_CHANGED = 'SELECT_VALUE_CHANGED';


// AUTH

export const AUTH = 'AUTH';
export const AUTH_PENDING = 'AUTH_PENDING';
export const AUTH_FULFILLED = 'AUTH_FULFILLED';
export const AUTH_REJECTED = 'AUTH_REJECTED';


export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';